import { removeNull } from '@/utils/handleData.js'
import { getLaborParentBidUid } from '@/utils/bidLevelActions.js'
import { daysFormat } from '@/filters'

function withTeamOnSiteCount(data) {
  if (!data || typeof data !== 'object') return data
  const payload = Object.assign({}, data)
  const raw = payload.onSiteCountInput
  if (raw === '' || raw === undefined || raw === null) {
    payload.onSiteCount = null
  } else {
    const n = Number(raw)
    payload.onSiteCount = isNaN(n) ? null : n
  }
  return payload
}

export default {
  namespaced: true,
  state: {
    teamList: {} // 作业班组列表
  },
  actions: {
    // 根据劳务公司自动生成班组名称
    async getTeamName({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/team/teamname',
          data: { laborTeamUid: uid }
        },
        { root: true }
      )
      return res && res.data ? res.data : ''
    },
    // 新建施工班组
    async addTeam({ dispatch }, data) {
      await dispatch('ensureForemanEntry', data)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/teaminfo',
          data: withTeamOnSiteCount(data),
          msg: '新建作业班组成功'
        },
        { root: true }
      )
      return res
    },
    // 删除施工班组
    async deleteTeam({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/teaminfo',
          data: { uid: uid },
          msg: '删除作业班组成功'
        },
        { root: true }
      )
      return res
    },
    // 获取施工班组列表
    async getTeamList({ rootState, rootGetters, commit, dispatch }) {
      var queryValues = await dispatch(
        'bidSection/ensureDefaultBidQuery',
        { queryKey: 'team', fieldKey: 'upVproUid' },
        { root: true }
      )
      queryValues = Object.assign({}, queryValues)
      if (rootGetters['user/orgType'] === 'laborCom') {
        const bidUid = getLaborParentBidUid({
          orgType: 'laborCom',
          orgValue: rootState.user.orgValue,
          state: rootState,
          getters: rootGetters
        })
        queryValues.organUid = bidUid || rootState.user.orgValue
        queryValues.upVproUid = bidUid || ''
        queryValues.downVproUid = rootState.user.orgValue
      }
      queryValues.page = rootState.page.team
      queryValues.limit = rootState.limit.team
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/team/baseinfo', data: queryValues },
        { root: true }
      )
      var teamList = res.data ? res.data : {}
      if (teamList.result && teamList.result.length) {
        const exitRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/temp/teaminfo/exitstatus',
            data: {
              uids: teamList.result.map((item) => item.uid).join(',')
            },
            noErrorMsg: true
          },
          { root: true }
        )
        const exitMap = {}
        if (exitRes && exitRes.data && Array.isArray(exitRes.data)) {
          exitRes.data.forEach((item) => {
            if (item && item.uid) {
              exitMap[item.uid] = item.isExit || item.isexit
            }
          })
        }
        const countRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/temp/teaminfo/onsitecounts',
            data: {
              uids: teamList.result.map((item) => item.uid).join(',')
            },
            noErrorMsg: true
          },
          { root: true }
        )
        const countMap = {}
        if (countRes && countRes.data && Array.isArray(countRes.data)) {
          countRes.data.forEach((item) => {
            if (item && item.uid) {
              countMap[item.uid] = item
            }
          })
        }
        const isSuperAdmin =
          rootState.user.userName === rootState.superAdminName
        const orgType = rootGetters['user/orgType']
        const orgValue = rootState.user.orgValue
        teamList.result.forEach((item) => {
          if (exitMap[item.uid]) {
            item.isExit = exitMap[item.uid]
          }
          const countRow = countMap[item.uid] || {}
          item.boundCount =
            countRow.boundCount != null
              ? Number(countRow.boundCount)
              : countRow.boundcount != null
              ? Number(countRow.boundcount)
              : 0
          item.onSiteCount =
            countRow.onSiteCount != null
              ? countRow.onSiteCount
              : countRow.onsitecount != null
              ? countRow.onsitecount
              : 0
          item.onSiteCountInput = item.onSiteCount
          item.disabledButtons = []
          item.teamSmallName = item.teamName.slice(3)
          const ownTeam =
            orgType === 'laborCom'
              ? item.downVproUid === orgValue
              : item.upVproUid === orgValue
          if (!ownTeam || item.isExit !== '在场') {
            item.disabledButtons = isSuperAdmin ? [1, 3, 4] : [1, 2, 3, 4]
          } else if (item.teamName.slice(0, 3) === 'BZA' && !isSuperAdmin) {
            item.disabledButtons = [2]
          }
        })
      }
      commit(
        'baseSet',
        { module: 'team', key: 'teamList', value: teamList },
        { root: true }
      )
    },
    // 编辑工程项目
    async editTeam({ dispatch }, data) {
      await dispatch('ensureForemanEntry', data)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/teaminfo',
          data: withTeamOnSiteCount(data),
          msg: '编辑作业班组成功'
        },
        { root: true }
      )
      return res
    },
    // 提交班组前：班组长若未在本劳务公司进场，则办理默认当日的劳务人员进场
    async ensureForemanEntry({ dispatch, rootState, rootGetters }, data) {
      const foremanUid = String((data && data.foremanUid) || '').trim()
      const laborUid = String((data && data.projectUid) || '').trim()
      if (!foremanUid || !laborUid) return

      const orgType = rootGetters['user/orgType']
      let bidUid = (data && data.upVproUid) || ''
      if (orgType === 'laborCom') {
        bidUid = getLaborParentBidUid({
          orgType: 'laborCom',
          orgValue: rootState.user.orgValue,
          state: rootState,
          getters: rootGetters
        })
      } else if (orgType === 'simPro') {
        bidUid = rootState.user.orgValue
      } else if (!bidUid) {
        const q = (rootState.queryValues && rootState.queryValues.team) || {}
        bidUid = q.upVproUid || ''
      }
      if (!bidUid) {
        const list =
          rootState.bidSection.unExitLaborCompanys ||
          rootState.bidSection.laborCompanyNames ||
          []
        const hit = list.find(
          (item) => item && String(item.value) === laborUid
        )
        bidUid =
          (hit && (hit.upVproUid || hit.upvprouid || hit.parentUid)) || ''
      }
      if (!bidUid) return

      let business = ''
      try {
        const list = await dispatch('person/getCurrentBusiness', foremanUid, {
          root: true
        })
        business =
          Array.isArray(list) && list[0]
            ? list[0].label || list[0].value || ''
            : ''
      } catch (e) {
        // 忽略，工种留空
      }

      try {
        await dispatch(
          'baseRequest',
          {
            method: 'POST',
            url: '/person/worker/labor',
            data: {
              personUid: foremanUid,
              laborTeamUid: laborUid,
              vProjectUid: bidUid,
              walkinDate: daysFormat(new Date()),
              business: business,
              isForeman: '1'
            },
            noErrorMsg: true
          },
          { root: true }
        )
      } catch (e) {
        // 已进场会返回“已进场”，忽略；其它异常也不阻断班组保存
      }
    },
    // 解散作业班组
    async dissolveTeam({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/teaminfo/dissolve',
          data: {
            uid: data.uid
          },
          msg: '班组解散成功'
        },
        { root: true }
      )
      return res
    },
    async getTeamPersons({ dispatch }, teamUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/teaminfo/persons',
          data: { teamUid: teamUid },
          noErrorMsg: true
        },
        { root: true }
      )
      return Array.isArray(res && res.data) ? res.data : []
    },
    async getTeamWorkContent({ dispatch }, uid) {
      if (!uid) return ''
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/teaminfo',
          data: {
            uid: uid,
            fields: 'uid,workContent'
          },
          noErrorMsg: true
        },
        { root: true }
      )
      const data = res && res.data
      const rows = Array.isArray(data) ? data : data ? [data] : []
      const row = rows[0] || {}
      const keys = Object.keys(row)
      for (let i = 0; i < keys.length; i++) {
        if (String(keys[i]).replace(/_/g, '').toLowerCase() === 'workcontent') {
          return row[keys[i]] || ''
        }
      }
      return ''
    },
    async bindTeamPersons({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/teaminfo/bindpersons',
          data: data,
          msg: '关联人员已更新'
        },
        { root: true }
      )
      return res
    }
  }
}
